const FreeComponent = () => {
    return (  
        <div>
            <h1 className="text-center">Free Component</h1>
        </div>
    );
}
 
export default FreeComponent;